export const FETCH_ORGANIZATIONS_REQUEST = 'FETCH_ORGANIZATIONS_REQUEST';
export const FETCH_ORGANIZATIONS_SUCCESS = 'FETCH_ORGANIZATIONS_SUCCESS';
export const FETCH_ORGANIZATIONS_FAILURE = 'FETCH_ORGANIZATIONS_FAILURE';

export const FETCH_ACCESS_ORGANIZATIONS_REQUEST = 'FETCH_ACCESS_ORGANIZATIONS_REQUEST';
export const FETCH_ACCESS_ORGANIZATIONS_SUCCESS = 'FETCH_ACCESS_ORGANIZATIONS_SUCCESS';
export const FETCH_ACCESS_ORGANIZATIONS_FAILURE = 'FETCH_ACCESS_ORGANIZATIONS_FAILURE';

